/* Desktop only: the class schedule sits in the right half of "Join BOXR", beside Membership / Classes / Personal training.
   Phones keep it in its own section further down. The node is moved, not copied, so the calendar keeps its state. */
(function () {
  var slot = document.querySelector("[data-sched-slot]"), mod = document.querySelector(".tonight__mod"), home = document.querySelector(".tonight");
  if (!slot || !mod || !home || !window.matchMedia) return;
  var parent = mod.parentNode, mq = window.matchMedia("(min-width: 1100px)");
  var place = function () {
    if (mq.matches) { if (mod.parentNode !== slot) slot.appendChild(mod); home.hidden = true; }
    else { if (mod.parentNode !== parent) parent.appendChild(mod); home.hidden = false; }
    document.documentElement.classList.toggle("has-split", mq.matches);
  };
  place();
  if (mq.addEventListener) mq.addEventListener("change", place); else mq.addListener(place);
})();
